require('./newDiskNameDialog.style.scss');

class NewDiskNameDialogController {
    constructor($scope, $timeout, $filter, $attrs, validationsService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$attrs = $attrs;
        this.modalTitle = this.$filter('translate')('vm.restore.options.cloneDisks.newDiskName.editDisk.title');
        this.validationsService = validationsService;
        this.namePattern = this.validationsService.getNewDiskNamePattern();
    }

    $onInit() {
        this.setActionButtons();

    }

    onOpen() {
        this.modalSubTitle = this.selectedDisk ? ' » ' + this.selectedDisk.value : "";
        this.index = this.diskIndex;
        if (this.newDiskNames && this.newDiskNames.length) {
            this.newDiskName = this.newDiskNames[this.index];
        }
    }

    setActionButtons() {
        this.actionButton = [{
            title: this.$filter('translate')('vm.restore.options.cloneDisks.newDiskName.button.save'),
            action: () => this.onNewDiskName(),
            isDisabled: () => this.isSaveDisabled(),
            id: this.$attrs.eventId + '-start',
            type: 'submit'
        }];
    }

    isSaveDisabled() {
        if (this.newDiskName) {
            return false;
        }
        return true;
    }

    onNewDiskName() {
        const newDiskName = this.newDiskName;
        const index = this.index;
        this.onSave({ newDiskName, index });
        this.showModal = false;
    }

}

NewDiskNameDialogController.$inject = ['$scope', '$timeout', '$filter', '$attrs', 'validationsService'];

const newDiskNameDialog = {
    controller: NewDiskNameDialogController,
    template: require('./newDiskNameDialog.template.html'),
    bindings: {
        showModal: '=',
        title: '@?',
        selectedDisk: '=?',
        onSave: '&',
        isSubModal: '<?',
        onSave: '&',
        diskIndex: '<',
        newDiskNames: '<'
    }
};

module.exports = newDiskNameDialog;


// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/recoverVm/dialogs/newDiskNameDialog.component.js